export default function Funnel({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.66439 4.79531C2.58307 4.70581 2.52945 4.59464 2.51005 4.47527C2.49065 4.35591 2.50629 4.23348 2.55508 4.12283C2.60388 4.01218 2.68372 3.91806 2.78494 3.85188C2.88616 3.7857 3.0044 3.75031 3.12533 3.75H16.8753C16.9964 3.75001 17.1149 3.78518 17.2163 3.85124C17.3178 3.9173 17.3978 4.0114 17.4468 4.12212C17.4958 4.23283 17.5116 4.35538 17.4922 4.47489C17.4729 4.5944 17.4192 4.70571 17.3378 4.79531L11.8753 10.625V15.207C11.8754 15.31 11.85 15.4113 11.8015 15.5021C11.753 15.5928 11.6828 15.6702 11.5972 15.7273L9.09721 17.3937C9.00317 17.4565 8.89388 17.4926 8.78097 17.4981C8.66806 17.5036 8.55576 17.4784 8.45603 17.4252C8.3563 17.372 8.27288 17.2927 8.21464 17.1958C8.15641 17.0989 8.12554 16.988 8.12533 16.875V10.625L2.66439 4.79531Z"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
